import React from 'react';
import {Card, CardActions, CardContent} from "@mui/material";
import {CardData, CardTitle} from "@atttomyx/react-components";
import {BannerAd} from "../misc";
import {datetime} from "@atttomyx/shared-utils";
import "./adCard.css";

const AdCard = (props) => {
    const { appRenderer, ad, filters, children } = props;

    return <Card className="ad-card" raised={true}>
        <CardContent>
            <CardTitle>
                <BannerAd imageUrl={ad.imageUrl} />
            </CardTitle>
            <CardData
                filters={filters}
                data={ad}
                keyToMetadata={{
                    appId: {
                        title: "App",
                        formatter: appRenderer.render,
                    },
                    clickUrl: {
                        title: "Click URL",
                    },
                    created: {
                        title: "Created",
                        formatter: datetime.getFullDateAndTime,
                    },
                    updated: {
                        title: "Updated",
                        formatter: datetime.getFullDateAndTime,
                    },
                }}
            />
        </CardContent>
        <CardActions disableSpacing={true}>
            {children}
        </CardActions>
    </Card>
}

export default AdCard;
